define('shared/initializer/form/adapters/Checkout',[
    '../constants',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    './Bootstrap3',
    './mixins/StoreOfferIdIntoState',
    './mixins/StoreCouponCodeIntoState',
    './mixins/Checkoutable',
    './mixins/CheckoutFlowControllable',
    './mixins/SubmissionLockable',
    './mixins/Ajaxable',
    './mixins/AjaxResultValidatable',
    './mixins/Loginable',
    './mixins/InputValuePersistable',
    './mixins/OmnitureTriggerable',
    './mixins/Redirectable',
    './mixins/ConversionTrackable',
    './mixins/EtagTrackable',
    './mixins/fields/Password',
    './mixins/LabelFloatable',
    './mixins/ThrobberOnBeforeSubmit',
    './mixins/FieldsPrefillable',
    './mixins/AfterSubmitActionTriggerable',
    './mixins/CrossDomainRetriever',
    './mixins/fields/Location',
    './mixins/HasRedemptionCodeUtil',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/tracking/pageName'
],
function  (
    constants,
    ctor,
    RSVP,
    Bootstrap3,
    StoreOfferIdIntoState,
    StoreCouponCodeIntoState,
    Checkoutable,
    CheckoutFlowControllable,
    SubmissionLockable,
    Ajaxable,
    AjaxResultValidatable,
    Loginable,
    InputValuePersistable,
    OmnitureTriggerable,
    Redirectable,
    ConversionTrackable,
    EtagTrackable,
    FieldPassword,
    LabelFloatable,
    ThrobberOnBeforeSubmit,
    FieldsPrefillable,
    AfterSubmitActionTriggerable,
    CrossDomainRetriever,
    LocationField,
    HasRedemptionCodeUtil,
    FormDataDispatcher,
    pageNameUtil
) {
    'use strict';

    var METHOD_BEFORE_REDIRECT = 'doBeforeRedirect';
    

    function createBeforeRedirectDelegate(callbackName, context) {
        function BeforeRedirectDelegate() {

        }

        BeforeRedirectDelegate.prototype.doAfterSubmit = function(data){
            return new RSVP.Promise(function(resolve, reject){
                if ( typeof context[callbackName] === 'function' ) {
                    context[callbackName](data)
                        .then(resolve, reject);
                }
                else {
                    resolve(data);
                }
            });
        };

        return BeforeRedirectDelegate;
    }

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply( null, arguments );

        me.lifeCycles.push(METHOD_BEFORE_REDIRECT);

        me.mixin(
            HasRedemptionCodeUtil,
            StoreOfferIdIntoState, 
            StoreCouponCodeIntoState,
            Checkoutable,
            CrossDomainRetriever,
            FieldsPrefillable,
            ThrobberOnBeforeSubmit,
            LocationField,
            FieldPassword,
            LabelFloatable,
            CheckoutFlowControllable,
            EtagTrackable,
            Ajaxable,
            AjaxResultValidatable,
            SubmissionLockable,
            Loginable,
            InputValuePersistable,
            ConversionTrackable,
            createBeforeRedirectDelegate(METHOD_BEFORE_REDIRECT, me),
            OmnitureTriggerable,
            AfterSubmitActionTriggerable,
            Redirectable
        );

        this.disableButtonAfterSubmit = true;

    }).inherit(Bootstrap3);

    var p = Ctor.prototype;

    p.doBeforeSubmit = function () {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                var dispatcher = new FormDataDispatcher( me.$form );
                return dispatcher.dispatch(
                {
                    items:
                    {
                        'omniture.name':
                        {
                            sources:
                            [{
                                retrieve: function(){return pageNameUtil.getConversionPageName.call(me);}
                            }],
                            targets:
                            [{
                                type: 'form',
                                key: constants.FIELD.OMNITURE_NAME
                            }]
                        }
                    },
                    timeout: 1 * 1000
                });
            });
    };

    return Ctor;
});

